import React, { useState, useEffect, useMemo } from "react";

import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";

// ==========================================
// 1. ICONS (รวมไอคอนทั้งหมดไว้ที่นี่ ไม่ต้องแก้)
// ==========================================
const IconPlus = ({ size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
);
const IconTrash = ({ size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </svg>
);
const IconSave = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <polyline points="17 21 17 13 7 13 7 21" />
    <polyline points="7 3 7 8 15 8" />
  </svg>
);
const IconArrowLeft = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m15 18-6-6 6-6" />
  </svg>
);
const IconBriefcase = ({ size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);
const IconUser = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const IconDollar = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const IconShopping = ({ size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
    <path d="M3 6h18" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);
const IconRefresh = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 2v6h-6" />
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
    <path d="M3 22v-6h6" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
  </svg>
);
const IconLink = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
const IconPrinter = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 6 2 18 2 18 9" />
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);
const IconClock = ({ size = 14, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconUsers = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const IconFileText = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);
// Additional Icons for Finance
const IconWallet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
    <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
  </svg>
);
const IconHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);
const IconTarget = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);
const IconActivity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);
const IconSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
const IconCamera = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
const IconX = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const IconBarChart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </svg>
);
const IconTrending = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);
const IconChevronDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);
const IconLogOut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" x2="9" y1="12" y2="12" />
  </svg>
);
// Category Icons
const IconFood = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17 8h1a4 4 0 1 1 0 8h-1"></path>
    <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"></path>
    <line x1="6" y1="1" x2="6" y2="4"></line>
    <line x1="10" y1="1" x2="10" y2="4"></line>
    <line x1="14" y1="1" x2="14" y2="4"></line>
  </svg>
);
const IconUtilities = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);
const IconWifi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
    <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
    <line x1="12" y1="20" x2="12.01" y2="20"></line>
  </svg>
);
const IconCar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"></path>
    <circle cx="7" cy="17" r="2"></circle>
    <path d="M9 17h6"></path>
    <circle cx="17" cy="17" r="2"></circle>
  </svg>
);
const IconPlay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="4" width="20" height="16" rx="4"></rect>
    <path d="m10 10 5 2.5-5 2.5V10z"></path>
  </svg>
);
const IconFilm = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="20" height="20" x="2" y="2" rx="2.18" ry="2.18"></rect>
    <line x1="7" x2="7" y1="2" y2="22"></line>
    <line x1="17" x2="17" y1="2" y2="22"></line>
    <line x1="2" x2="22" y1="12" y2="12"></line>
    <line x1="2" x2="7" y1="7" y2="7"></line>
    <line x1="2" x2="7" y1="17" y2="17"></line>
    <line x1="17" x2="22" y1="17" y2="17"></line>
    <line x1="17" x2="22" y1="7" y2="7"></line>
  </svg>
);
const IconBanknote = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="20" height="12" x="2" y="6" rx="2"></rect>
    <circle cx="12" cy="12" r="2"></circle>
    <path d="M6 12h.01M18 12h.01"></path>
  </svg>
);
const IconStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);
const IconBitcoin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.279 5.304m5.908 1.042-.347 1.97m1.563 8.864c-.642 1.054-1.233 2.112-1.216 6.894m-1.216-6.894c-3.612-.638-3.918-1.558-4.342-2.953-.642-2.112.642-4.224 4.342-4.862m-1.216 6.894c.643-1.054 1.234-2.112 1.216-6.893m-1.216 6.893c-3.612-.638-3.918-1.558-4.342-2.953-.642-2.112.642-4.224 4.342-4.862"></path>
  </svg>
);
const IconPiggy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19 5c-1.5 0-2.8.6-3.5 1.5A10.3 10.3 0 0 0 9 5c-5.5 0-10 4.5-10 10 0 1.2.2 2.4.7 3.5a10 10 0 0 0 18.6 0c.5-1.1.7-2.3.7-3.5 0-5.5-4.5-10-10-10Z"></path>
    <path d="M15.7 17.5c-.7.8-1.7 1.5-3.2 1.5a4 4 0 0 1-3.2-1.5"></path>
    <path d="M13.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"></path>
    <path d="M8.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"></path>
  </svg>
);
const IconOther = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="1" />
    <circle cx="19" cy="12" r="1" />
    <circle cx="5" cy="12" r="1" />
  </svg>
);

// ==========================================
// 2. PROJECT APP: Components
// ==========================================
const COLORS = ["#10B981", "#3B82F6", "#F59E0B", "#EF4444"];

const ItemRow = ({ item, index, onChange, onDelete, type }) => (
  <div className="grid grid-cols-12 gap-2 items-center bg-slate-800/40 p-2 rounded-lg border border-slate-700/50 mb-2 print:bg-white print:border-b print:border-slate-300 print:rounded-none">
    <div className="col-span-5">
      <input
        type="text"
        placeholder={type === "Labor" ? "ชื่อทีมงาน..." : "รายการ..."}
        className="w-full bg-transparent text-sm text-white outline-none placeholder-slate-600 print:text-black"
        value={item.Name}
        onChange={(e) => onChange(index, "Name", e.target.value)}
      />
    </div>
    <div className="col-span-2">
      <input
        type="number"
        placeholder={type === "Labor" ? "วัน" : "จำนวน"}
        className="w-full bg-slate-900/50 rounded px-1 py-1 text-sm text-white text-center outline-none border border-slate-700 focus:border-emerald-500 print:bg-white print:text-black print:border-none"
        value={item.Qty}
        onChange={(e) => onChange(index, "Qty", e.target.value)}
      />
    </div>
    <div className="col-span-2">
      <input
        type="number"
        placeholder="ราคา"
        className="w-full bg-slate-900/50 rounded px-1 py-1 text-sm text-white text-right outline-none border border-slate-700 focus:border-emerald-500 print:bg-white print:text-black print:border-none"
        value={item.Rate}
        onChange={(e) => onChange(index, "Rate", e.target.value)}
      />
    </div>
    <div className="col-span-2 text-right text-sm font-bold text-slate-300 print:text-black">
      {(
        (parseFloat(item.Qty) || 0) * (parseFloat(item.Rate) || 0)
      ).toLocaleString()}
    </div>
    <div className="col-span-1 text-center print:hidden">
      <button
        onClick={() => onDelete(index)}
        className="text-slate-600 hover:text-red-400 p-1"
      >
        <IconTrash />
      </button>
    </div>
  </div>
);

const FileRow = ({ item, index, onChange, onDelete }) => (
  <div className="grid grid-cols-12 gap-2 items-center bg-slate-800/40 p-2 rounded-lg border border-slate-700/50 mb-2 print:bg-white print:border-b print:border-slate-300">
    <div className="col-span-4">
      <input
        type="text"
        placeholder="ชื่อเอกสาร (เช่น ใบเสนอราคา)..."
        className="w-full bg-transparent text-sm text-white outline-none placeholder-slate-600 print:text-black"
        value={item.Name}
        onChange={(e) => onChange(index, "Name", e.target.value)}
      />
    </div>
    <div className="col-span-7">
      <input
        type="text"
        placeholder="https://drive.google.com/..."
        className="w-full bg-slate-900/50 rounded px-2 py-1 text-xs text-blue-400 outline-none border border-slate-700 focus:border-blue-500 print:bg-white print:text-blue-600 print:border-none"
        value={item.LinkUrl}
        onChange={(e) => onChange(index, "LinkUrl", e.target.value)}
      />
    </div>
    <div className="col-span-1 text-center print:hidden">
      <button
        onClick={() => onDelete(index)}
        className="text-slate-600 hover:text-red-400 p-1"
      >
        <IconTrash />
      </button>
    </div>
  </div>
);

const ProjectCalculator = ({ project, onSave, onBack }) => {
  const [header, setHeader] = useState({
    ProjectID: project?.ProjectID || null,
    ProjectName: project?.ProjectName || "",
    Customer: project?.Customer || "",
    QuotedAmount: project?.QuotedAmount || 0,
    ProducerFeeType: project?.ProducerFeeType || "Percent",
    ProducerFeeInput: project?.ProducerFeeInput || 25,
    StartDate: project?.StartDate || "",
    EndDate: project?.EndDate || "",
  });
  const [laborList, setLaborList] = useState(
    project?.laborList || [{ Name: "", Qty: 0, Rate: 0 }]
  );
  const [producerList, setProducerList] = useState(
    project?.producerList || [{ Name: "", Qty: 1, Rate: 0 }]
  );
  const [expenseList, setExpenseList] = useState(
    project?.expenseList || [{ Name: "", Qty: 1, Rate: 0 }]
  );
  const [fileList, setFileList] = useState(
    project?.fileList || [{ Name: "", LinkUrl: "" }]
  );
  const [saving, setSaving] = useState(false);

  const calcTotal = (list) =>
    list.reduce(
      (sum, i) => sum + parseFloat(i.Qty || 0) * parseFloat(i.Rate || 0),
      0
    );
  const totalLabor = calcTotal(laborList);
  const totalProducerItems = calcTotal(producerList);
  const totalExpense = calcTotal(expenseList);
  const producerFee =
    header.ProducerFeeType === "Percent"
      ? (parseFloat(header.QuotedAmount || 0) *
          parseFloat(header.ProducerFeeInput || 0)) /
        100
      : parseFloat(header.ProducerFeeInput || 0);
  const totalProducerFinal = totalProducerItems + producerFee;
  const centralFund =
    parseFloat(header.QuotedAmount || 0) -
    totalLabor -
    totalProducerFinal -
    totalExpense;

  const handleHeaderChange = (field, value) =>
    setHeader((prev) => ({ ...prev, [field]: value }));
  const handleListChange = (list, setList, idx, field, val) => {
    const newList = [...list];
    newList[idx][field] = val;
    setList(newList);
  };
  const addItem = (list, setList, defaultItem) =>
    setList([...list, defaultItem]);
  const removeItem = (list, setList, idx) =>
    setList(list.filter((_, i) => i !== idx));

  const handleSave = async () => {
    if (!header.ProjectName) return alert("กรุณาใส่ชื่อโปรเจกต์");
    setSaving(true);
    await onSave({
      ...header,
      CentralFund: centralFund,
      laborList: laborList.filter((i) => i.Name !== ""),
      producerList: producerList.filter((i) => i.Name !== ""),
      expenseList: expenseList.filter((i) => i.Name !== ""),
      fileList: fileList.filter((i) => i.Name !== ""),
    });
    setSaving(false);
  };
  const handlePrint = () => {
    window.print();
  };

  const chartData = [
    { name: "Labor", value: totalLabor },
    { name: "Producer", value: totalProducerFinal },
    { name: "Expenses", value: totalExpense },
    { name: "Central", value: Math.max(0, centralFund) },
  ];
  const TableHeader = ({ titleQty, titleRate }) => (
    <div className="grid grid-cols-12 gap-2 mb-1 px-2 text-[10px] text-slate-500 uppercase print:text-gray-500">
      <div className="col-span-5">รายการ</div>
      <div className="col-span-2 text-center">{titleQty}</div>
      <div className="col-span-2 text-right">{titleRate}</div>
      <div className="col-span-2 text-right">รวม</div>
      <div className="col-span-1"></div>
    </div>
  );

  return (
    <div className="animate-fadeIn pb-20 bg-[#0F111A] min-h-screen text-slate-100 p-4 print:bg-white print:text-black print:p-0">
      <div className="flex items-center justify-between mb-6 sticky top-0 bg-[#0F111A]/90 backdrop-blur-sm z-20 py-3 border-b border-slate-800 print:hidden">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-2 bg-slate-800 rounded-full hover:bg-slate-700 text-slate-400"
          >
            <IconArrowLeft />
          </button>
          <h2 className="text-lg font-bold text-white">
            {header.ProjectID ? "แก้ไขโครงการ" : "สร้างโครงการใหม่"}
          </h2>
        </div>
        <div className="flex gap-2">
          <button
            onClick={handlePrint}
            className="flex items-center gap-2 bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg font-bold text-sm transition"
          >
            <IconPrinter size={16} /> Print PDF
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white px-4 py-2 rounded-lg font-bold text-sm transition disabled:opacity-50"
          >
            {saving ? (
              "Saving..."
            ) : (
              <>
                <IconSave size={16} /> บันทึก
              </>
            )}
          </button>
        </div>
      </div>

      <div className="hidden print:block mb-8 text-center border-b pb-4">
        <h1 className="text-3xl font-bold text-black">
          ใบสรุปต้นทุนโครงการ (Project Costing)
        </h1>
        <p className="text-gray-500">JP Japan Planner System</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 print:block">
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-lg print:bg-white print:border print:border-gray-300 print:shadow-none print:mb-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-emerald-400 font-bold text-sm uppercase flex items-center gap-2 print:text-black">
                <IconBriefcase /> ข้อมูลทั่วไป
              </h3>
              <div className="flex items-center gap-2 bg-slate-900 px-3 py-1 rounded-lg border border-yellow-500/30 print:bg-gray-100 print:border-gray-300">
                <span className="text-xs text-yellow-500 font-bold print:text-black">
                  ยอดเสนอราคา
                </span>
                <input
                  type="number"
                  className="w-32 bg-transparent text-right text-xl font-bold text-white outline-none print:text-black"
                  value={header.QuotedAmount}
                  onChange={(e) =>
                    handleHeaderChange("QuotedAmount", e.target.value)
                  }
                  placeholder="0.00"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                className="bg-slate-900 border border-slate-700 rounded-lg p-2 text-sm text-white outline-none print:bg-white print:border-gray-300 print:text-black"
                value={header.ProjectName}
                onChange={(e) =>
                  handleHeaderChange("ProjectName", e.target.value)
                }
                placeholder="ชื่อโครงการ..."
              />
              <input
                type="text"
                className="bg-slate-900 border border-slate-700 rounded-lg p-2 text-sm text-white outline-none print:bg-white print:border-gray-300 print:text-black"
                value={header.Customer}
                onChange={(e) => handleHeaderChange("Customer", e.target.value)}
                placeholder="ลูกค้า..."
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="text-xs">
                <span className="text-slate-500 block mb-1">เริ่ม</span>
                <input
                  type="date"
                  className="bg-slate-900 border border-slate-700 rounded p-1 text-white w-full print:text-black print:bg-white print:border-gray-300"
                  value={header.StartDate}
                  onChange={(e) =>
                    handleHeaderChange("StartDate", e.target.value)
                  }
                />
              </div>
              <div className="text-xs">
                <span className="text-slate-500 block mb-1">สิ้นสุด</span>
                <input
                  type="date"
                  className="bg-slate-900 border border-slate-700 rounded p-1 text-white w-full print:text-black print:bg-white print:border-gray-300"
                  value={header.EndDate}
                  onChange={(e) =>
                    handleHeaderChange("EndDate", e.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-lg print:bg-white print:border print:border-gray-300 print:shadow-none print:mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-blue-400 font-bold text-sm uppercase flex items-center gap-2 print:text-black">
                <IconUser /> ค่าแรงทีมงาน (Labor)
              </h3>
              <button
                onClick={() =>
                  addItem(laborList, setLaborList, {
                    Name: "",
                    Qty: 0,
                    Rate: 0,
                  })
                }
                className="text-[10px] bg-blue-600/20 text-blue-400 px-3 py-1 rounded-full hover:bg-blue-600/30 flex gap-1 items-center print:hidden"
              >
                <IconPlus size={12} /> เพิ่มคน
              </button>
            </div>
            <TableHeader titleQty="วัน" titleRate="ค่าแรง/วัน" />
            {laborList.map((item, i) => (
              <ItemRow
                key={i}
                item={item}
                index={i}
                type="Labor"
                onChange={(idx, f, v) =>
                  handleListChange(laborList, setLaborList, idx, f, v)
                }
                onDelete={(idx) => removeItem(laborList, setLaborList, idx)}
              />
            ))}
            <div className="text-right text-sm mt-2 pt-2 border-t border-slate-700 print:border-gray-300">
              รวมค่าแรง:{" "}
              <span className="text-blue-400 font-bold print:text-black">
                {totalLabor.toLocaleString()}
              </span>
            </div>
          </div>

          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-lg print:bg-white print:border print:border-gray-300 print:shadow-none print:mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-orange-400 font-bold text-sm uppercase flex items-center gap-2 print:text-black">
                <IconDollar /> ค่า Producer
              </h3>
              <button
                onClick={() =>
                  addItem(producerList, setProducerList, {
                    Name: "",
                    Qty: 1,
                    Rate: 0,
                  })
                }
                className="text-[10px] bg-orange-500/20 text-orange-400 px-3 py-1 rounded-full hover:bg-orange-500/30 flex gap-1 items-center print:hidden"
              >
                <IconPlus size={12} /> เพิ่มรายการ
              </button>
            </div>
            <TableHeader titleQty="จำนวน" titleRate="ราคา/หน่วย" />
            {producerList.map((item, i) => (
              <ItemRow
                key={i}
                item={item}
                index={i}
                type="Other"
                onChange={(idx, f, v) =>
                  handleListChange(producerList, setProducerList, idx, f, v)
                }
                onDelete={(idx) =>
                  removeItem(producerList, setProducerList, idx)
                }
              />
            ))}
            <div className="mt-4 p-3 bg-slate-900/50 rounded-lg border border-slate-700 print:bg-white print:border-gray-300">
              <div className="flex justify-between items-center">
                <span className="text-sm text-slate-300 print:text-black">
                  หักค่าบริหาร (Fee)
                </span>
                <div className="flex items-center gap-2">
                  <div className="flex bg-slate-800 rounded p-1 print:hidden">
                    <button
                      onClick={() =>
                        handleHeaderChange("ProducerFeeType", "Percent")
                      }
                      className={`px-2 py-0.5 text-[10px] rounded ${
                        header.ProducerFeeType === "Percent"
                          ? "bg-orange-500 text-white"
                          : "text-slate-400"
                      }`}
                    >
                      %
                    </button>
                    <button
                      onClick={() =>
                        handleHeaderChange("ProducerFeeType", "Fixed")
                      }
                      className={`px-2 py-0.5 text-[10px] rounded ${
                        header.ProducerFeeType === "Fixed"
                          ? "bg-orange-500 text-white"
                          : "text-slate-400"
                      }`}
                    >
                      ฿
                    </button>
                  </div>
                  <input
                    type="number"
                    className="w-20 bg-slate-800 text-right text-white rounded px-2 py-1 outline-none text-sm print:bg-white print:border print:border-gray-300 print:text-black"
                    value={header.ProducerFeeInput}
                    onChange={(e) =>
                      handleHeaderChange("ProducerFeeInput", e.target.value)
                    }
                  />
                  <span className="text-xs text-slate-500 print:hidden">
                    {header.ProducerFeeType === "Percent" ? "%" : "THB"}
                  </span>
                </div>
              </div>
              <div className="text-right text-xs text-orange-400 font-bold mt-1 print:text-black">
                คิดเป็นเงิน: {producerFee.toLocaleString()}
              </div>
            </div>
            <div className="text-right text-sm mt-2 pt-2 border-t border-slate-700 print:border-gray-300">
              รวม Producer ทั้งหมด:{" "}
              <span className="text-orange-400 font-bold print:text-black">
                {totalProducerFinal.toLocaleString()}
              </span>
            </div>
          </div>

          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-lg print:bg-white print:border print:border-gray-300 print:shadow-none print:mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-purple-400 font-bold text-sm uppercase flex items-center gap-2 print:text-black">
                <IconShopping /> ค่าใช้จ่ายอื่นๆ (Expenses)
              </h3>
              <button
                onClick={() =>
                  addItem(expenseList, setExpenseList, {
                    Name: "",
                    Qty: 1,
                    Rate: 0,
                  })
                }
                className="text-[10px] bg-purple-500/20 text-purple-400 px-3 py-1 rounded-full hover:bg-purple-500/30 flex gap-1 items-center print:hidden"
              >
                <IconPlus size={12} /> เพิ่มรายการ
              </button>
            </div>
            <TableHeader titleQty="จำนวน" titleRate="ราคา/หน่วย" />
            {expenseList.map((item, i) => (
              <ItemRow
                key={i}
                item={item}
                index={i}
                type="Other"
                onChange={(idx, f, v) =>
                  handleListChange(expenseList, setExpenseList, idx, f, v)
                }
                onDelete={(idx) => removeItem(expenseList, setExpenseList, idx)}
              />
            ))}
            <div className="text-right text-sm mt-2 pt-2 border-t border-slate-700 print:border-gray-300">
              รวมค่าใช้จ่ายอื่นๆ:{" "}
              <span className="text-purple-400 font-bold print:text-black">
                {totalExpense.toLocaleString()}
              </span>
            </div>
          </div>

          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-lg print:hidden">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-slate-300 font-bold text-sm uppercase flex items-center gap-2">
                <IconLink /> เอกสารแนบ / ลิงก์
              </h3>
              <button
                onClick={() =>
                  addItem(fileList, setFileList, { Name: "", LinkUrl: "" })
                }
                className="text-[10px] bg-slate-700 text-slate-300 px-3 py-1 rounded-full hover:bg-slate-600 flex gap-1 items-center"
              >
                <IconPlus size={12} /> เพิ่มลิงก์
              </button>
            </div>
            {fileList.map((item, i) => (
              <FileRow
                key={i}
                item={item}
                index={i}
                onChange={(idx, f, v) =>
                  handleListChange(fileList, setFileList, idx, f, v)
                }
                onDelete={(idx) => removeItem(fileList, setFileList, idx)}
              />
            ))}
          </div>
        </div>

        <div className="lg:col-span-1 space-y-6 print:break-before-page">
          <div className="bg-[#1E2130] p-5 rounded-2xl border border-slate-700 shadow-xl sticky top-24 print:static print:bg-white print:border print:border-gray-300 print:shadow-none">
            <h3 className="text-white font-bold text-lg mb-4 text-center print:text-black">
              สรุปโครงการ
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between p-2 bg-slate-900/50 rounded print:bg-gray-100 print:text-black">
                <span>ยอดเสนอราคา</span>
                <span className="text-yellow-400 font-bold print:text-black">
                  ฿{parseFloat(header.QuotedAmount || 0).toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between p-2 border-b border-slate-800 print:border-gray-300 print:text-black">
                <span>- ค่าแรง</span>{" "}
                <span className="text-blue-400 font-bold print:text-black">
                  {totalLabor.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between p-2 border-b border-slate-800 print:border-gray-300 print:text-black">
                <span>- Producer</span>{" "}
                <span className="text-orange-400 font-bold print:text-black">
                  {totalProducerFinal.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between p-2 border-b border-slate-800 print:border-gray-300 print:text-black">
                <span>- ค่าใช้จ่ายอื่น</span>{" "}
                <span className="text-purple-400 font-bold print:text-black">
                  {totalExpense.toLocaleString()}
                </span>
              </div>
              <div
                className={`mt-4 p-4 rounded-xl border-2 border-dashed ${
                  centralFund >= 0
                    ? "border-emerald-500/50 bg-emerald-500/5"
                    : "border-red-500/50 bg-red-500/5"
                } flex flex-col items-center justify-center gap-1 print:border-black print:bg-white`}
              >
                <span
                  className={`text-xs uppercase font-bold ${
                    centralFund >= 0 ? "text-emerald-400" : "text-red-400"
                  } print:text-black`}
                >
                  เข้ากองกลาง (Central Fund)
                </span>
                <span
                  className={`text-3xl font-black ${
                    centralFund >= 0 ? "text-emerald-400" : "text-red-400"
                  } print:text-black`}
                >
                  ฿
                  {centralFund.toLocaleString(undefined, {
                    maximumFractionDigits: 0,
                  })}
                </span>
              </div>
              <div className="h-40 mt-4 print:hidden">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={chartData}
                      innerRadius={35}
                      outerRadius={55}
                      paddingAngle={5}
                      dataKey="value"
                    >
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                      ))}
                    </Pie>
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#0f172a",
                        borderRadius: "8px",
                        border: "none",
                        fontSize: "12px",
                      }}
                      itemStyle={{ color: "#fff" }}
                      formatter={(value) => `฿${value.toLocaleString()}`}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// 3. MAIN PROJECT APP
// ==========================================
const ProjectApp = ({ onSwitchToFinance }) => {
  const [apiUrl] = useState(
    "https://script.google.com/macros/s/AKfycbyfoS3vuxjGD37CvPLiuyOSJmlEvylxYChiNshvGT19zr1ONdRQjeU8l10nPKeFdayJ/exec"
  );
  const [activeTab, setActiveTab] = useState("projects");
  const [projects, setProjects] = useState([]);
  const [editingProject, setEditingProject] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}?action=getProjects`);
      const json = await res.json();
      if (json.status === "success") setProjects(json.data);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleSaveProject = async (projectData) => {
    setLoading(true);
    await fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify({ action: "saveProject", ...projectData }),
    });
    await fetchData();
    setEditingProject(null);
    setActiveTab("projects");
    setLoading(false);
  };
  const handleDeleteProject = async (id) => {
    if (!window.confirm("Delete project?")) return;
    setLoading(true);
    await fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify({ action: "deleteProject", id }),
    });
    fetchData();
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0F111A] text-slate-100 font-sans">
      {activeTab === "calculator" ? (
        <div className="max-w-6xl mx-auto p-4 print:p-0">
          <ProjectCalculator
            project={editingProject}
            onSave={handleSaveProject}
            onBack={() => {
              setEditingProject(null);
              setActiveTab("projects");
            }}
          />
        </div>
      ) : (
        <div className="max-w-5xl mx-auto p-6 print:hidden">
          <header className="flex justify-between items-center mb-8">
            <h1 className="text-2xl font-bold text-white">
              Project Management
            </h1>
            <div className="flex gap-2">
              {/* 🔴 BUTTON TO FINANCE APP */}
              <button
                onClick={onSwitchToFinance}
                className="flex items-center gap-2 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white px-4 py-2 rounded-lg font-bold shadow-lg transition"
              >
                <IconTrending size={20} /> Finance
              </button>
              <button
                onClick={fetchData}
                className="p-2 bg-slate-800 rounded-lg hover:text-white"
              >
                <IconRefresh />
              </button>
            </div>
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <button
              onClick={() => {
                setEditingProject({});
                setActiveTab("calculator");
              }}
              className="flex flex-col items-center justify-center gap-3 bg-slate-800/30 border-2 border-dashed border-slate-700 rounded-2xl min-h-[200px] text-slate-500 hover:border-emerald-500 hover:text-emerald-500 transition"
            >
              <div className="p-4 bg-slate-800 rounded-full">
                <IconPlus size={28} />
              </div>
              <span className="font-bold">New Project</span>
            </button>
            {projects.map((p) => {
              const labor = (p.laborList || []).reduce(
                (s, i) => s + parseFloat(i.Total || 0),
                0
              );
              const prodItems = (p.producerList || []).reduce(
                (s, i) => s + parseFloat(i.Total || 0),
                0
              );
              const exp = (p.expenseList || []).reduce(
                (s, i) => s + parseFloat(i.Total || 0),
                0
              );
              const quote = parseFloat(p.QuotedAmount || 0);
              const prodFeeInput = parseFloat(p.ProducerFeeInput || 0);
              const prodFee =
                p.ProducerFeeType === "Percent"
                  ? (quote * prodFeeInput) / 100
                  : prodFeeInput;
              const totalProd = prodItems + prodFee;
              const centralFund = quote - labor - totalProd - exp;
              return (
                <div
                  key={p.ProjectID}
                  onClick={() => {
                    setEditingProject(p);
                    setActiveTab("calculator");
                  }}
                  className="bg-[#1E2130] p-5 rounded-2xl border border-slate-800 hover:border-emerald-500/50 cursor-pointer transition relative group"
                >
                  <h3 className="text-lg font-bold text-white mb-1 truncate">
                    {p.ProjectName}
                  </h3>
                  <p className="text-xs text-slate-400 mb-4">{p.Customer}</p>
                  <div className="flex justify-between text-xs mb-2">
                    <span className="text-slate-500">Quote</span>
                    <span className="text-white font-bold">
                      ฿{quote.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between text-xs pt-2 border-t border-slate-700">
                    <span className="text-slate-500">Central Fund</span>
                    <span
                      className={`font-bold ${
                        centralFund >= 0 ? "text-emerald-400" : "text-red-400"
                      }`}
                    >
                      ฿{centralFund.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-[10px] text-slate-500 pt-3 mt-2 border-t border-slate-800">
                    <span className="flex items-center gap-1">
                      <IconUser size={12} /> {(p.laborList || []).length}
                    </span>
                    <span className="ml-auto">
                      {p.StartDate ? p.StartDate.slice(0, 10) : "-"}
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteProject(p.ProjectID);
                    }}
                    className="absolute top-4 right-4 p-2 text-slate-600 hover:text-red-400 opacity-0 group-hover:opacity-100 transition"
                  >
                    <IconTrash />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {loading && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
          <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// 4. FINANCE APP: Config & Helpers
// ==========================================
const ASSET_GROUPS = {
  LIQUID: {
    id: "LIQUID",
    title: "สภาพคล่อง",
    types: ["Bank", "Cash", "Wallet", "USDT", "Savings"],
    color: "#10B981",
  },
  INVESTMENT: {
    id: "INVESTMENT",
    title: "การลงทุน",
    types: ["Lottery", "Insurance", "Fund", "Stock", "BTC", "Gold"],
    color: "#3B82F6",
  },
  PERSONAL: {
    id: "PERSONAL",
    title: "ทรัพย์สินส่วนตัว",
    types: ["Car", "House", "Personal"],
    color: "#8B5CF6",
  },
  LIABILITY: {
    id: "LIABILITY",
    title: "หนี้สิน",
    types: ["Credit Card", "Loan", "Debt"],
    color: "#EF4444",
  },
};
const THAI_MONTHS_SHORT = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
const CHART_COLORS = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#EC4899",
  "#6366F1",
  "#14B8A6",
  "#84CC16",
];
const CATEGORIES_CONFIG = {
  Expense: [
    {
      label: "อาหารและเครื่องดื่ม",
      icon: <IconFood size={24} />,
      color: "text-orange-400 bg-orange-400/20",
    },
    {
      label: "ช้อปปิ้ง",
      icon: <IconShopping size={24} />,
      color: "text-pink-400 bg-pink-400/20",
    },
    {
      label: "ค่าเดินทาง",
      icon: <IconCar size={24} />,
      color: "text-yellow-400 bg-yellow-400/20",
    },
    {
      label: "ค่าไฟค่าน้ำ",
      icon: <IconUtilities size={24} />,
      color: "text-blue-400 bg-blue-400/20",
    },
    {
      label: "ค่าอินเตอร์เน็ต",
      icon: <IconWifi size={24} />,
      color: "text-cyan-400 bg-cyan-400/20",
    },
    {
      label: "Youtube",
      icon: <IconPlay size={24} />,
      color: "text-red-500 bg-red-500/20",
    },
    {
      label: "Netflix",
      icon: <IconFilm size={24} />,
      color: "text-red-600 bg-red-600/20",
    },
    {
      label: "ลงทุน",
      icon: <IconTrending size={24} />,
      color: "text-green-400 bg-green-400/20",
    },
    {
      label: "ออมเงิน",
      icon: <IconPiggy size={24} />,
      color: "text-purple-400 bg-purple-400/20",
    },
    {
      label: "อื่นๆ",
      icon: <IconOther size={24} />,
      color: "text-slate-400 bg-slate-400/20",
    },
  ],
  Income: [
    {
      label: "เงินเดือน",
      icon: <IconBanknote size={24} />,
      color: "text-emerald-400 bg-emerald-400/20",
    },
    {
      label: "Freelance",
      icon: <IconBriefcase size={24} />,
      color: "text-purple-400 bg-purple-400/20",
    },
    {
      label: "เงินรางวัล",
      icon: <IconStar size={24} />,
      color: "text-yellow-400 bg-yellow-400/20",
    },
    {
      label: "กำไรจาก Crypto",
      icon: <IconBitcoin size={24} />,
      color: "text-orange-500 bg-orange-500/20",
    },
    {
      label: "อื่นๆ",
      icon: <IconOther size={24} />,
      color: "text-slate-400 bg-slate-400/20",
    },
  ],
};
const getCurrentDateTimeLocal = (dateObj) => {
  const d = dateObj || new Date();
  const pad = (num) => String(num).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};
const parseDateSafe = (dateStr) => {
  if (!dateStr) return null;
  let d = new Date(dateStr);
  if (!isNaN(d.getTime())) return d;
  const matches = String(dateStr).match(
    /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/
  );
  if (matches) {
    const day = parseInt(matches[1], 10);
    const month = parseInt(matches[2], 10) - 1;
    const year = parseInt(matches[3], 10);
    const timeMatch = String(dateStr).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    let hours = 0,
      mins = 0,
      secs = 0;
    if (timeMatch) {
      hours = parseInt(timeMatch[1], 10);
      mins = parseInt(timeMatch[2], 10);
      secs = timeMatch[3] ? parseInt(timeMatch[3], 10) : 0;
    }
    return new Date(year, month, day, hours, mins, secs);
  }
  return null;
};
const formatThaiDate = (dateStr) => {
  const d = parseDateSafe(dateStr);
  if (!d) return "-";
  return `${d.getDate()} ${THAI_MONTHS_SHORT[d.getMonth()]} ${
    d.getFullYear() + 543
  }`;
};

// ==========================================
// 5. FINANCE APP: Components
// ==========================================
const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const ENV_USER =
    process.env.NEXT_PUBLIC_BASIC_AUTH_USER ||
    process.env.REACT_APP_BASIC_AUTH_USER ||
    "dmai";
  const ENV_PASS =
    process.env.NEXT_PUBLIC_BASIC_AUTH_PASSWORD ||
    process.env.REACT_APP_BASIC_AUTH_PASSWORD ||
    "Heart2momaxpetong";

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setTimeout(() => {
      if (username === ENV_USER && password === ENV_PASS) {
        onLogin();
      } else {
        setError("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
        setLoading(false);
      }
    }, 800);
  };
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4 font-sans text-slate-100">
      <div className="w-full max-w-sm bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-2xl relative overflow-hidden">
        <div className="text-center mb-8 relative z-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-600 rounded-3xl shadow-lg shadow-emerald-500/20 mb-4">
            <IconWallet size={40} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Dmai</h1>
          <p className="text-slate-400 text-sm mt-2">
            เข้าสู่ระบบเพื่อจัดการการเงิน
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5 relative z-10">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 text-slate-200 text-sm rounded-xl p-3.5 outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 text-slate-200 text-sm rounded-xl p-3.5 outline-none"
              required
            />
          </div>
          {error && (
            <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 text-xs text-center font-bold animate-pulse">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-500 hover:from-emerald-500 hover:to-emerald-400 font-bold rounded-xl text-sm px-5 py-4 shadow-lg shadow-emerald-500/20 transition-all disabled:opacity-70"
          >
            {loading ? "กำลังตรวจสอบ..." : "เข้าสู่ระบบ"}
          </button>
        </form>
      </div>
    </div>
  );
};

const FinanceApp = ({ onBackToProject }) => {
  const [apiUrl] = useState(
    "https://script.google.com/macros/s/AKfycbyfoS3vuxjGD37CvPLiuyOSJmlEvylxYChiNshvGT19zr1ONdRQjeU8l10nPKeFdayJ/exec"
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthChecking, setIsAuthChecking] = useState(true);
  const [assets, setAssets] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [assetHistory, setAssetHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [chartViewMode, setChartViewMode] = useState("spending");
  const [assetSubMode, setAssetSubMode] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const [filterCategory, setFilterCategory] = useState("All Categories");
  const [filterDateRange, setFilterDateRange] = useState("All Time");
  const [isProcessingImg, setIsProcessingImg] = useState(false);
  const [preview, setPreview] = useState(null);
  const [form, setForm] = useState({
    amount: "",
    note: "",
    type: "Expense",
    assetId: "",
    category: "",
    date: getCurrentDateTimeLocal(),
  });
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [isCreatingAsset, setIsCreatingAsset] = useState(false);
  const [newAssetForm, setNewAssetForm] = useState({
    name: "",
    value: "",
    type: "Bank",
  });
  const [editingAsset, setEditingAsset] = useState(null);

  useEffect(() => {
    const storedAuth = localStorage.getItem("isLoggedIn");
    if (storedAuth === "true") setIsAuthenticated(true);
    setIsAuthChecking(false);
  }, []);
  useEffect(() => {
    if (isAuthenticated) refreshData();
  }, [isAuthenticated]);
  const handleLoginSuccess = () => {
    localStorage.setItem("isLoggedIn", "true");
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsAuthenticated(false);
  };
  const refreshData = () => {
    setLoading(true);
    Promise.all([
      fetch(`${apiUrl}?action=getAssets`)
        .then((r) => r.json())
        .then((j) => j.data),
      fetch(`${apiUrl}?action=getTransactions`)
        .then((r) => r.json())
        .then((j) => j.data),
      fetch(`${apiUrl}?action=getHistory`)
        .then((r) => r.json())
        .then((j) => j.data),
    ]).then(([a, t, h]) => {
      setAssets(a || []);
      setTransactions(t || []);
      setAssetHistory(h || []);
      if (a?.length > 0 && !form.assetId)
        setForm((prev) => ({ ...prev, assetId: a[0].ID }));
      setLoading(false);
    });
  };
  const getAssetGroupType = (type) => {
    for (const k in ASSET_GROUPS)
      if (ASSET_GROUPS[k].types.includes(type)) return ASSET_GROUPS[k];
    return ASSET_GROUPS.PERSONAL;
  };

  const dashboardData = useMemo(() => {
    const yearTrans = transactions.filter((t) => {
      const d = parseDateSafe(t.Date);
      return d && d.getFullYear() === selectedYear;
    });
    const monthTrans = yearTrans.filter((t) => {
      const d = parseDateSafe(t.Date);
      return d && d.getMonth() === selectedMonth;
    });
    const totalIncome = monthTrans
      .filter((t) => t.Type === "Income")
      .reduce((s, t) => s + parseFloat(t.Amount), 0);
    const totalExpense = monthTrans
      .filter((t) => t.Type === "Expense")
      .reduce((s, t) => s + parseFloat(t.Amount), 0);
    const catMap = {};
    monthTrans
      .filter((t) => t.Type === "Expense")
      .forEach((t) => {
        catMap[t.Category || "Other"] =
          (catMap[t.Category || "Other"] || 0) + parseFloat(t.Amount);
      });
    const topCatName =
      Object.keys(catMap).sort((a, b) => catMap[b] - catMap[a])[0] || "-";
    const topCatAmount = catMap[topCatName] || 0;
    const spendingDonutData = Object.keys(catMap)
      .map((k) => ({ name: k, value: catMap[k] }))
      .sort((a, b) => b.value - a.value);
    const spendingTrendData = Array(12)
      .fill(0)
      .map((_, i) => ({ name: THAI_MONTHS_SHORT[i], Income: 0, Expense: 0 }));
    yearTrans.forEach((t) => {
      const d = parseDateSafe(t.Date);
      if (d) {
        if (t.Type === "Income")
          spendingTrendData[d.getMonth()].Income += parseFloat(t.Amount);
        else spendingTrendData[d.getMonth()].Expense += parseFloat(t.Amount);
      }
    });
    const assetTrendData = [];
    const today = new Date();
    for (let i = 5; i >= 0; i--) {
      const targetDate = new Date(
        today.getFullYear(),
        today.getMonth() - i + 1,
        0
      );
      targetDate.setHours(23, 59, 59, 999);
      let totalAsset = 0;
      let totalDebt = 0;
      assets.forEach((asset) => {
        const isDebt = getAssetGroupType(asset.Type).id === "LIABILITY";
        const history = assetHistory
          .map((h) => ({ ...h, d: parseDateSafe(h.Date) }))
          .filter((h) => h.d && h.d <= targetDate && h.Asset_ID === asset.ID)
          .sort((a, b) => b.d - a.d);
        let val = 0;
        if (history.length > 0) val = parseFloat(history[0].Value);
        else {
          if (i === 0) val = parseFloat(asset.Current_Value);
          else val = 0;
        }
        if (isDebt) totalDebt += val;
        else totalAsset += val;
      });
      assetTrendData.push({
        name: THAI_MONTHS_SHORT[targetDate.getMonth()],
        Assets: totalAsset,
        Liabilities: totalDebt,
        NetWorth: totalAsset - totalDebt,
      });
    }
    const assetGroupMap = {};
    assets
      .filter((a) => getAssetGroupType(a.Type).id !== "LIABILITY")
      .forEach((a) => {
        const g = getAssetGroupType(a.Type);
        assetGroupMap[g.title] =
          (assetGroupMap[g.title] || 0) + parseFloat(a.Current_Value);
      });
    const assetDonutData = Object.keys(assetGroupMap).map((k) => ({
      name: k,
      value: assetGroupMap[k],
    }));
    const liquidMap = {};
    assets
      .filter((a) => getAssetGroupType(a.Type).id === "LIQUID")
      .forEach((a) => {
        liquidMap[a.Asset_Name] =
          (liquidMap[a.Asset_Name] || 0) + parseFloat(a.Current_Value);
      });
    const liquidDonutData = Object.keys(liquidMap)
      .map((k) => ({ name: k, value: liquidMap[k] }))
      .sort((a, b) => b.value - a.value);
    const investMap = {};
    assets
      .filter((a) => getAssetGroupType(a.Type).id === "INVESTMENT")
      .forEach((a) => {
        investMap[a.Type] =
          (investMap[a.Type] || 0) + parseFloat(a.Current_Value);
      });
    const investDonutData = Object.keys(investMap)
      .map((k) => ({ name: k, value: investMap[k] }))
      .sort((a, b) => b.value - a.value);
    return {
      totalExpense,
      totalIncome,
      topCatName,
      topCatAmount,
      spendingTrendData,
      spendingDonutData,
      assetTrendData,
      assetDonutData,
      liquidDonutData,
      investDonutData,
    };
  }, [transactions, selectedMonth, selectedYear, assets, assetHistory]);

  const getDisplayDonutData = () => {
    if (chartViewMode === "spending") return dashboardData.spendingDonutData;
    if (assetSubMode === "LIQUID") return dashboardData.liquidDonutData;
    if (assetSubMode === "INVESTMENT") return dashboardData.investDonutData;
    return dashboardData.assetDonutData;
  };
  const getDisplayDonutTotal = () => {
    if (chartViewMode === "spending") return dashboardData.totalExpense;
    return getDisplayDonutData().reduce((s, i) => s + i.value, 0);
  };
  const filteredTransactions = useMemo(() => {
    let f = [...transactions];
    if (searchText)
      f = f.filter(
        (t) =>
          (t.Note && t.Note.toLowerCase().includes(searchText.toLowerCase())) ||
          (t.Category &&
            t.Category.toLowerCase().includes(searchText.toLowerCase())) ||
          t.Amount.toString().includes(searchText)
      );
    if (filterCategory !== "All Categories")
      f = f.filter((t) => t.Category === filterCategory);
    const now = new Date();
    if (filterDateRange === "1 Day")
      f = f.filter((t) => {
        const d = parseDateSafe(t.Date);
        return d && d.toDateString() === now.toDateString();
      });
    else if (filterDateRange === "1 Week") {
      const w = new Date();
      w.setDate(now.getDate() - 7);
      f = f.filter((t) => {
        const d = parseDateSafe(t.Date);
        return d && d >= w;
      });
    } else if (filterDateRange === "This Month")
      f = f.filter((t) => {
        const d = parseDateSafe(t.Date);
        return (
          d &&
          d.getMonth() === now.getMonth() &&
          d.getFullYear() === now.getFullYear()
        );
      });
    else if (filterDateRange === "Last Month") {
      const lm = new Date();
      lm.setMonth(now.getMonth() - 1);
      f = f.filter((t) => {
        const d = parseDateSafe(t.Date);
        return (
          d &&
          d.getMonth() === lm.getMonth() &&
          d.getFullYear() === lm.getFullYear()
        );
      });
    }
    return f.sort((a, b) => parseDateSafe(b.Date) - parseDateSafe(a.Date));
  }, [transactions, searchText, filterCategory, filterDateRange]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    setIsProcessingImg(true);
    setStatus("📷 กำลังอ่านสลิป...");
    try {
      const result = await Tesseract.recognize(file, "eng+tha");
      const text = result.data.text;
      const amountMatch = text.match(/[\d,]+\.\d{2}/);
      const matches = text.match(/(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{2,4})/);
      let foundDate = null;
      if (matches) {
        const day = parseInt(matches[1]);
        const month = parseInt(matches[2]);
        let year = parseInt(matches[3]);
        if (year < 100) year += 2000;
        if (year > 2400) year -= 543;
        foundDate = new Date(year, month - 1, day);
        const now = new Date();
        foundDate.setHours(now.getHours());
        foundDate.setMinutes(now.getMinutes());
      }
      setForm((prev) => ({
        ...prev,
        amount: amountMatch ? amountMatch[0].replace(/,/g, "") : prev.amount,
        note: "Scan from Slip",
        date: foundDate ? getCurrentDateTimeLocal(foundDate) : prev.date,
      }));
      setStatus("✅ อ่านข้อมูลแล้ว");
    } catch (err) {
      setStatus("❌ อ่านรูปไม่สำเร็จ");
    }
    setIsProcessingImg(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.assetId) return alert("เลือกบัญชี");
    if (!form.category) return alert("เลือกหมวดหมู่");
    setLoading(true);
    try {
      await fetch(apiUrl, {
        method: "POST",
        body: JSON.stringify({
          action: "addTransaction",
          ...form,
          imageUrl: "",
        }),
      });
      setStatus("🎉 บันทึกสำเร็จ!");
      setForm((prev) => ({
        ...prev,
        amount: "",
        note: "",
        category: "",
        date: getCurrentDateTimeLocal(),
      }));
      setPreview(null);
      setShowRecordModal(false);
      refreshData();
      setTimeout(() => setStatus(""), 2000);
    } catch (error) {
      setStatus("❌ Error");
    }
    setLoading(false);
  };
  const handleUpdateTransaction = async () => {
    if (!editingTransaction) return;
    setLoading(true);
    try {
      await fetch(apiUrl, {
        method: "POST",
        body: JSON.stringify({
          action: "updateTransaction",
          id: editingTransaction.ID,
          date: editingTransaction.date,
          type: editingTransaction.Type,
          category: editingTransaction.Category,
          amount: editingTransaction.Amount,
          note: editingTransaction.Note,
          assetId: editingTransaction.Asset_ID,
        }),
      });
      setStatus("✅ แก้ไขเรียบร้อย");
      setEditingTransaction(null);
      refreshData();
    } catch (error) {
      setStatus("❌ แก้ไขไม่สำเร็จ");
    }
    setLoading(false);
  };
  const handleDeleteTransaction = async () => {
    if (!editingTransaction) return;
    if (!window.confirm("ต้องการลบรายการนี้ใช่ไหม?")) return;
    setLoading(true);
    try {
      await fetch(apiUrl, {
        method: "POST",
        body: JSON.stringify({
          action: "deleteTransaction",
          id: editingTransaction.ID,
        }),
      });
      setStatus("🗑️ ลบเรียบร้อย");
      setEditingTransaction(null);
      refreshData();
    } catch (error) {
      setStatus("❌ ลบไม่สำเร็จ");
    }
    setLoading(false);
  };
  const handleCreateAsset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(apiUrl, {
        method: "POST",
        body: JSON.stringify({ action: "addAsset", ...newAssetForm }),
      });
      setIsCreatingAsset(false);
      refreshData();
    } catch (err) {}
    setLoading(false);
  };
  const handleUpdateAsset = async () => {
    if (!editingAsset) return;
    setLoading(true);
    try {
      await fetch(apiUrl, {
        method: "POST",
        body: JSON.stringify({
          action: "updateAsset",
          id: editingAsset.ID,
          value: editingAsset.Current_Value,
          date: editingAsset.date || getCurrentDateTimeLocal(),
        }),
      });
      setEditingAsset(null);
      refreshData();
    } catch (err) {}
    setLoading(false);
  };

  const yearOptions = Array.from(
    { length: 5 },
    (_, i) => new Date().getFullYear() - i + 1
  );
  const allCategories = useMemo(
    () => [
      "All Categories",
      ...new Set(
        Object.values(CATEGORIES_CONFIG).flatMap((g) => g.map((c) => c.label))
      ),
    ],
    []
  );

  if (isAuthChecking)
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center text-emerald-500">
        Loading...
      </div>
    );
  if (!isAuthenticated) return <Login onLogin={handleLoginSuccess} />;

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 font-sans relative overflow-hidden">
      <div className="max-w-7xl mx-auto p-4 md:p-6 w-full space-y-8">
        <header className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3 self-start md:self-auto">
            <button
              onClick={onBackToProject}
              className="p-2 bg-slate-800 rounded-xl hover:bg-slate-700 text-slate-300 mr-2 border border-slate-700"
            >
              <IconArrowLeft size={20} />
            </button>
            <div className="bg-emerald-600 p-2 rounded-xl shadow-lg shadow-emerald-500/20">
              <IconWallet className="text-white w-6 h-6" />
            </div>
            <h1 className="text-2xl font-bold text-white">Dmai</h1>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 bg-slate-900 p-1 rounded-xl border border-slate-800 self-end md:self-auto">
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                className="px-3 py-1.5 text-xs font-bold bg-slate-800 rounded-lg text-slate-300 outline-none border-none cursor-pointer hover:text-white"
              >
                {yearOptions.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
              <button
                onClick={refreshData}
                className="p-2 hover:bg-slate-800 rounded-lg text-slate-400"
              >
                <IconRefresh size={16} />
              </button>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 bg-red-900/20 text-red-400 border border-red-900 rounded-xl hover:bg-red-900/40"
              title="Logout"
            >
              <IconLogOut size={16} />
            </button>
          </div>
        </header>

        <div className="flex overflow-x-auto gap-2 pb-2 scrollbar-hide">
          {THAI_MONTHS_SHORT.map((m, i) => (
            <button
              key={i}
              onClick={() => setSelectedMonth(i)}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all ${
                selectedMonth === i
                  ? "bg-emerald-600 text-white shadow-lg shadow-emerald-600/30"
                  : "bg-slate-900 text-slate-400 border border-slate-800 hover:bg-slate-800"
              }`}
            >
              {m === "ธ.ค." && selectedMonth !== i ? "ธ.ค." : m}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-emerald-600 rounded-3xl p-6 shadow-2xl shadow-emerald-900/50 relative overflow-hidden">
            <div className="absolute -right-4 -bottom-4 opacity-20 text-emerald-900">
              <IconWallet size={120} />
            </div>
            <p className="text-emerald-100 text-sm font-medium mb-1">
              รายจ่ายรวม (เดือนนี้)
            </p>
            <h2 className="text-3xl font-bold text-white mb-2">
              ฿{dashboardData.totalExpense.toLocaleString()}
            </h2>
            <div className="inline-flex items-center gap-1 bg-emerald-500/30 px-2 py-1 rounded-lg text-xs text-white font-bold backdrop-blur-sm">
              <span className="text-emerald-100">
                รายรับ: ฿{dashboardData.totalIncome.toLocaleString()}
              </span>
            </div>
          </div>
          <div className="bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl relative">
            <div className="flex justify-between items-start mb-2">
              <div>
                <p className="text-slate-400 text-sm font-medium">
                  หมวดหมู่สูงสุด
                </p>
                <h3 className="text-lg font-bold text-white truncate max-w-[120px]">
                  {dashboardData.topCatName}
                </h3>
              </div>
              <div className="bg-blue-500/20 p-2 rounded-lg text-blue-400">
                <IconHome size={20} />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-slate-200 mb-1">
              ฿{dashboardData.topCatAmount.toLocaleString()}
            </h2>
          </div>
          <div className="bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl border-l-4 border-l-amber-500">
            <div className="flex justify-between items-start mb-2">
              <p className="text-slate-400 text-sm font-medium">
                คาดการณ์สิ้นเดือน
              </p>
              <div className="bg-amber-500/20 p-2 rounded-lg text-amber-500">
                <IconTarget size={20} />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-slate-200 mb-4">
              ฿
              {(dashboardData.totalExpense * 1.1).toLocaleString(undefined, {
                maximumFractionDigits: 0,
              })}
            </h2>
          </div>
          <div
            className={`rounded-3xl p-6 border shadow-xl ${
              dashboardData.totalIncome - dashboardData.totalExpense >= 0
                ? "bg-slate-900 border-slate-800"
                : "bg-red-900/20 border-red-900/50"
            }`}
          >
            <div className="flex justify-between items-start mb-2">
              <p className="text-slate-400 text-sm font-medium">
                เงินคงเหลือ (เดือนนี้)
              </p>
              <div className="bg-slate-800 p-2 rounded-lg text-slate-400">
                <IconActivity size={20} />
              </div>
            </div>
            <h2
              className={`text-2xl font-bold mb-4 ${
                dashboardData.totalIncome - dashboardData.totalExpense >= 0
                  ? "text-emerald-400"
                  : "text-red-400"
              }`}
            >
              {dashboardData.totalIncome - dashboardData.totalExpense >= 0
                ? "+"
                : ""}
              ฿
              {(
                dashboardData.totalIncome - dashboardData.totalExpense
              ).toLocaleString()}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <span className="w-1 h-6 bg-slate-700 rounded-full"></span>
                {chartViewMode === "spending"
                  ? `Yearly Spending Trend (${selectedYear})`
                  : "Net Worth Trend (Last 6 Months)"}
              </h3>
              <div className="flex bg-slate-800 p-1 rounded-xl">
                <button
                  onClick={() => setChartViewMode("spending")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition ${
                    chartViewMode === "spending"
                      ? "bg-emerald-600 text-white shadow"
                      : "text-slate-400 hover:text-white"
                  }`}
                >
                  <IconBarChart size={14} /> รายรับ-รายจ่าย
                </button>
                <button
                  onClick={() => setChartViewMode("assets")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition ${
                    chartViewMode === "assets"
                      ? "bg-yellow-500 text-slate-900 shadow"
                      : "text-slate-400 hover:text-white"
                  }`}
                >
                  <IconTrending size={14} /> สินทรัพย์
                </button>
              </div>
            </div>
            <div className="h-64 w-full">
              <ResponsiveContainer width="100%" height="100%">
                {chartViewMode === "spending" ? (
                  <BarChart data={dashboardData.spendingTrendData} barSize={20}>
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke="#1e293b"
                      vertical={false}
                    />
                    <XAxis
                      dataKey="name"
                      stroke="#64748b"
                      tick={{ fontSize: 10 }}
                      axisLine={false}
                      tickLine={false}
                      dy={10}
                    />
                    <YAxis
                      stroke="#64748b"
                      tick={{ fontSize: 10 }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#0f172a",
                        borderColor: "#334155",
                        borderRadius: "12px",
                        color: "#fff",
                      }}
                      cursor={{ fill: "#1e293b" }}
                      formatter={(val) => val.toLocaleString()}
                    />
                    <Legend />
                    <Bar
                      dataKey="Income"
                      name="รายรับ"
                      stackId="a"
                      fill="#10B981"
                      radius={[0, 0, 4, 4]}
                    />
                    <Bar
                      dataKey="Expense"
                      name="รายจ่าย"
                      stackId="a"
                      fill="#3B82F6"
                      radius={[4, 4, 0, 0]}
                    />
                  </BarChart>
                ) : (
                  <LineChart data={dashboardData.assetTrendData}>
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke="#1e293b"
                      vertical={false}
                    />
                    <XAxis
                      dataKey="name"
                      stroke="#64748b"
                      tick={{ fontSize: 10 }}
                      axisLine={false}
                      tickLine={false}
                      dy={10}
                    />
                    <YAxis
                      stroke="#64748b"
                      tick={{ fontSize: 10 }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#0f172a",
                        borderColor: "#334155",
                        borderRadius: "12px",
                        color: "#fff",
                      }}
                      formatter={(val) => val.toLocaleString()}
                    />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="Assets"
                      name="สินทรัพย์"
                      stroke="#FACC15"
                      strokeWidth={3}
                      dot={{ r: 4 }}
                    />
                    <Line
                      type="monotone"
                      dataKey="Liabilities"
                      name="หนี้สิน"
                      stroke="#EF4444"
                      strokeWidth={3}
                      dot={{ r: 4 }}
                    />
                    <Line
                      type="monotone"
                      dataKey="NetWorth"
                      name="ความมั่งคั่งสุทธิ"
                      stroke="#2DD4BF"
                      strokeWidth={2}
                      strokeDasharray="5 5"
                    />
                  </LineChart>
                )}
              </ResponsiveContainer>
            </div>
          </div>
          <div className="lg:col-span-4 bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl flex flex-col">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="text-lg font-bold text-white">
                  {chartViewMode === "spending"
                    ? "Monthly Categories"
                    : "Asset Allocation"}
                </h3>
                {chartViewMode === "assets" && (
                  <div className="flex gap-2 mt-2">
                    <button
                      onClick={() => setAssetSubMode("ALL")}
                      className={`text-[10px] px-2 py-1 rounded border ${
                        assetSubMode === "ALL"
                          ? "bg-slate-700 text-white border-slate-600"
                          : "text-slate-500 border-slate-800 hover:border-slate-700"
                      }`}
                    >
                      All
                    </button>
                    <button
                      onClick={() => setAssetSubMode("LIQUID")}
                      className={`text-[10px] px-2 py-1 rounded border ${
                        assetSubMode === "LIQUID"
                          ? "bg-slate-700 text-white border-slate-600"
                          : "text-slate-500 border-slate-800 hover:border-slate-700"
                      }`}
                    >
                      สภาพคล่อง
                    </button>
                    <button
                      onClick={() => setAssetSubMode("INVESTMENT")}
                      className={`text-[10px] px-2 py-1 rounded border ${
                        assetSubMode === "INVESTMENT"
                          ? "bg-slate-700 text-white border-slate-600"
                          : "text-slate-500 border-slate-800 hover:border-slate-700"
                      }`}
                    >
                      การลงทุน
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-1 min-h-[200px] relative">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={getDisplayDonutData()}
                    innerRadius={60}
                    outerRadius={80}
                    paddingAngle={5}
                    dataKey="value"
                  >
                    {getDisplayDonutData().map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={CHART_COLORS[index % CHART_COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#0f172a",
                      borderColor: "#334155",
                      borderRadius: "8px",
                      color: "#fff",
                    }}
                    itemStyle={{ color: "#fff" }}
                    formatter={(val) => `฿${val.toLocaleString()}`}
                  />
                </PieChart>
              </ResponsiveContainer>
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <span className="text-xs text-slate-500">TOTAL</span>
                <span className="text-lg font-bold text-white">
                  ฿{getDisplayDonutTotal().toLocaleString()}
                </span>
              </div>
            </div>
            <div className="space-y-2 mt-4 max-h-40 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-slate-700">
              {getDisplayDonutData().map((d, i) => {
                const total = getDisplayDonutTotal();
                const percent =
                  total > 0 ? ((d.value / total) * 100).toFixed(1) : "0.0";
                return (
                  <div
                    key={i}
                    className="flex justify-between items-center text-xs"
                  >
                    <div className="flex items-center gap-2">
                      <span
                        className="w-2 h-2 rounded-full"
                        style={{
                          backgroundColor:
                            CHART_COLORS[i % CHART_COLORS.length],
                        }}
                      ></span>
                      <span className="text-slate-300 truncate max-w-[100px]">
                        {d.name}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="font-bold text-slate-200">
                        ฿{d.value.toLocaleString()}
                      </span>
                      <span className="text-slate-500 w-10 text-right">
                        {percent}%
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-white mb-4">
            Recent Transactions
          </h3>
          <div className="bg-slate-900 p-2 rounded-2xl border border-slate-800 mb-4 flex flex-col md:flex-row gap-2">
            <div className="relative flex-1">
              <IconSearch className="absolute left-3 top-3 text-slate-500 w-4 h-4" />
              <input
                type="text"
                placeholder="Search..."
                className="w-full bg-slate-950 border border-slate-800 rounded-xl pl-10 pr-4 py-2.5 text-sm text-white focus:border-emerald-500 outline-none transition"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="relative">
              <select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="w-full md:w-48 bg-slate-950 border border-slate-800 text-slate-300 text-sm rounded-xl px-4 py-2.5 outline-none appearance-none cursor-pointer hover:border-emerald-500/50 transition"
              >
                {allCategories.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <IconChevronDown className="absolute right-3 top-3 text-slate-500 w-4 h-4 pointer-events-none" />
            </div>
            <div className="relative">
              <select
                value={filterDateRange}
                onChange={(e) => setFilterDateRange(e.target.value)}
                className="w-full md:w-40 bg-slate-950 border border-slate-800 text-slate-300 text-sm rounded-xl px-4 py-2.5 outline-none appearance-none cursor-pointer hover:border-emerald-500/50 transition"
              >
                <option>All Time</option>
                <option>1 Day</option>
                <option>1 Week</option>
                <option>This Month</option>
                <option>Last Month</option>
              </select>
              <IconClock className="absolute right-3 top-3 text-slate-500 w-4 h-4 pointer-events-none" />
            </div>
          </div>
          <div className="bg-slate-900 rounded-3xl border border-slate-800 overflow-hidden">
            <div className="grid grid-cols-12 gap-4 p-4 text-xs font-bold text-slate-500 uppercase border-b border-slate-800">
              <div className="col-span-6 md:col-span-5">Transaction</div>
              <div className="col-span-3 hidden md:block">Category</div>
              <div className="col-span-3 md:col-span-2">Date</div>
              <div className="col-span-3 md:col-span-2 text-right">Amount</div>
            </div>
            <div className="divide-y divide-slate-800">
              {filteredTransactions.slice(0, 10).map((t, i) => (
                <div
                  key={t.ID}
                  onClick={() =>
                    setEditingTransaction({
                      ...t,
                      date: getCurrentDateTimeLocal(parseDateSafe(t.Date)),
                    })
                  }
                  className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-slate-800/50 transition cursor-pointer active:bg-slate-800"
                >
                  <div className="col-span-6 md:col-span-5 flex items-center gap-3">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${
                        t.Type === "Expense"
                          ? "bg-slate-800 text-slate-400"
                          : "bg-emerald-900/30 text-emerald-400"
                      }`}
                    >
                      {t.Type === "Expense" ? "🛍️" : "💰"}
                    </div>
                    <span className="font-bold text-slate-200 text-sm truncate">
                      {t.Note || "รายการทั่วไป"}
                    </span>
                  </div>
                  <div className="col-span-3 hidden md:block text-slate-400 text-sm">
                    {t.Category || "-"}
                  </div>
                  <div className="col-span-3 md:col-span-2 text-slate-500 text-sm">
                    {formatThaiDate(t.Date)}
                  </div>
                  <div
                    className={`col-span-3 md:col-span-2 text-right font-bold text-sm ${
                      t.Type === "Expense"
                        ? "text-slate-200"
                        : "text-emerald-400"
                    }`}
                  >
                    {t.Type === "Expense" ? "-" : "+"} ฿
                    {parseFloat(t.Amount).toLocaleString()}
                  </div>
                </div>
              ))}
              {filteredTransactions.length === 0 && (
                <div className="text-center py-10 text-slate-600">
                  ไม่พบรายการที่ค้นหา
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mb-24 animate-fadeIn">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-white">My Assets</h3>
            <button
              onClick={() => setIsCreatingAsset(true)}
              className="text-xs bg-slate-800 text-emerald-400 px-3 py-1.5 rounded-full border border-slate-700 hover:bg-slate-700"
            >
              + Add New
            </button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {Object.values(ASSET_GROUPS).map((group) => {
              const groupAssets = assets.filter(
                (a) => getAssetGroupType(a.Type).id === group.id
              );
              const total = groupAssets.reduce(
                (sum, a) => sum + (parseFloat(a.Current_Value) || 0),
                0
              );
              return (
                <div
                  key={group.id}
                  className="bg-slate-900 rounded-2xl border border-slate-800 p-4"
                >
                  <div className="flex justify-between items-center mb-3">
                    <h4
                      className="font-bold text-sm"
                      style={{ color: group.color }}
                    >
                      {group.title}
                    </h4>
                    <span className="text-white font-bold text-sm">
                      ฿{total.toLocaleString()}
                    </span>
                  </div>
                  <div className="space-y-2">
                    {groupAssets.length > 0 ? (
                      groupAssets.map((asset) => (
                        <div
                          key={asset.ID}
                          onClick={() =>
                            setEditingAsset({
                              ...asset,
                              date: getCurrentDateTimeLocal(),
                            })
                          }
                          className="flex justify-between text-xs text-slate-400 hover:bg-slate-800 p-2 rounded-lg cursor-pointer transition"
                        >
                          <span>{asset.Asset_Name}</span>
                          <span className="text-slate-200">
                            ฿{parseFloat(asset.Current_Value).toLocaleString()}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="text-xs text-slate-600 text-center py-2">
                        ไม่มีรายการ
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <button
        onClick={() => setShowRecordModal(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-emerald-600 hover:bg-emerald-500 text-white rounded-full shadow-2xl shadow-emerald-600/40 flex items-center justify-center active:scale-95 transition-all z-40 border-4 border-slate-950"
      >
        <IconPlus size={28} />
      </button>

      {showRecordModal && (
        <div className="fixed inset-0 bg-slate-950/90 backdrop-blur-md z-50 flex items-center justify-center p-4">
          <div className="bg-slate-900 w-full max-w-md rounded-3xl border border-slate-700 shadow-2xl p-6 relative animate-fadeIn max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowRecordModal(false)}
              className="absolute top-4 right-4 text-slate-400 hover:text-white"
            >
              <IconX />
            </button>
            <h2 className="text-xl font-bold text-white mb-6">บันทึกรายการ</h2>
            {preview && (
              <img
                src={preview}
                className="w-full h-32 object-cover rounded-xl mb-4 border border-slate-700"
                alt="slip"
              />
            )}
            <label className="flex gap-2 w-full bg-slate-800 border border-dashed border-slate-600 text-slate-400 rounded-xl p-4 cursor-pointer hover:bg-slate-700 mb-4 justify-center">
              <IconCamera />
              <span className="text-sm">สแกนสลิป</span>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onClick={(e) => (e.target.value = null)}
                onChange={handleImageUpload}
              />
            </label>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="flex bg-slate-950 p-1 rounded-xl border border-slate-800">
                <button
                  type="button"
                  onClick={() => setForm({ ...form, type: "Expense" })}
                  className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${
                    form.type === "Expense"
                      ? "bg-red-500 text-white"
                      : "text-slate-500"
                  }`}
                >
                  รายจ่าย
                </button>
                <button
                  type="button"
                  onClick={() => setForm({ ...form, type: "Income" })}
                  className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${
                    form.type === "Income"
                      ? "bg-emerald-500 text-white"
                      : "text-slate-500"
                  }`}
                >
                  รายรับ
                </button>
              </div>
              <div>
                <label className="text-xs text-slate-500 ml-2">ยอดเงิน</label>
                <input
                  type="number"
                  required
                  value={form.amount}
                  onChange={(e) => setForm({ ...form, amount: e.target.value })}
                  className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white text-center text-2xl font-bold outline-none focus:border-emerald-500"
                  placeholder="0.00"
                />
              </div>
              <div>
                <label className="text-xs text-slate-500 ml-2">วันที่</label>
                <input
                  type="datetime-local"
                  lang="en-GB"
                  required
                  value={form.date}
                  onChange={(e) => setForm({ ...form, date: e.target.value })}
                  className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white text-xs outline-none focus:border-emerald-500 scheme-dark"
                />
              </div>
              <div>
                <label className="text-xs text-slate-500 ml-2 mb-2 block">
                  หมวดหมู่
                </label>
                <div className="grid grid-cols-4 gap-2">
                  {CATEGORIES_CONFIG[form.type].map((cat) => (
                    <button
                      key={cat.label}
                      type="button"
                      onClick={() => setForm({ ...form, category: cat.label })}
                      className={`flex flex-col items-center justify-center p-2 rounded-xl border transition ${
                        form.category === cat.label
                          ? "border-emerald-500 bg-emerald-500/10 text-white"
                          : "border-slate-800 bg-slate-950 text-slate-400 hover:border-slate-700"
                      }`}
                    >
                      <div className={`p-2 rounded-full mb-1 ${cat.color}`}>
                        {cat.icon}
                      </div>
                      <span className="text-[10px] font-medium text-center leading-tight">
                        {cat.label}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="text-xs text-slate-500 ml-2">บัญชี</label>
                <select
                  value={form.assetId}
                  onChange={(e) =>
                    setForm({ ...form, assetId: e.target.value })
                  }
                  className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white outline-none"
                >
                  {Object.values(ASSET_GROUPS).map((g) => (
                    <optgroup key={g.id} label={g.title}>
                      {assets
                        .filter((a) => getAssetGroupType(a.Type).id === g.id)
                        .map((a) => (
                          <option key={a.ID} value={a.ID}>
                            {a.Asset_Name}
                          </option>
                        ))}
                    </optgroup>
                  ))}
                </select>
              </div>
              <input
                type="text"
                value={form.note}
                onChange={(e) => setForm({ ...form, note: e.target.value })}
                className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white outline-none focus:border-emerald-500"
                placeholder="บันทึกช่วยจำ..."
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 rounded-xl shadow-lg transition"
              >
                บันทึก
              </button>
            </form>
          </div>
        </div>
      )}

      {editingTransaction && (
        <div className="fixed inset-0 bg-slate-950/90 backdrop-blur-md z-50 flex items-center justify-center p-4">
          <div className="bg-slate-900 w-full max-w-md rounded-3xl border border-slate-700 shadow-2xl p-6 relative animate-fadeIn max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setEditingTransaction(null)}
              className="absolute top-4 right-4 text-slate-400 hover:text-white"
            >
              <IconX />
            </button>
            <h2 className="text-xl font-bold text-white mb-6">แก้ไขรายการ</h2>
            <div className="space-y-4">
              <div className="flex bg-slate-950 p-1 rounded-xl border border-slate-800">
                <button
                  onClick={() =>
                    setEditingTransaction({
                      ...editingTransaction,
                      Type: "Expense",
                      Category: "",
                    })
                  }
                  className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${
                    editingTransaction.Type === "Expense"
                      ? "bg-red-500 text-white"
                      : "text-slate-500"
                  }`}
                >
                  รายจ่าย
                </button>
                <button
                  onClick={() =>
                    setEditingTransaction({
                      ...editingTransaction,
                      Type: "Income",
                      Category: "",
                    })
                  }
                  className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${
                    editingTransaction.Type === "Income"
                      ? "bg-emerald-500 text-white"
                      : "text-slate-500"
                  }`}
                >
                  รายรับ
                </button>
              </div>
              <input
                type="number"
                value={editingTransaction.Amount}
                onChange={(e) =>
                  setEditingTransaction({
                    ...editingTransaction,
                    Amount: e.target.value,
                  })
                }
                className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white text-center text-2xl font-bold outline-none"
              />
              <div>
                <label className="text-xs text-slate-500 ml-2">วันที่</label>
                <input
                  type="datetime-local"
                  lang="en-GB"
                  value={editingTransaction.date}
                  step="60"
                  onChange={(e) =>
                    setEditingTransaction({
                      ...editingTransaction,
                      date: e.target.value,
                    })
                  }
                  className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white outline-none scheme-dark"
                />
              </div>
              <div>
                <label className="text-xs text-slate-500 ml-2 mb-2 block">
                  หมวดหมู่
                </label>
                <div className="grid grid-cols-4 gap-2">
                  {CATEGORIES_CONFIG[editingTransaction.Type].map((cat) => (
                    <button
                      key={cat.label}
                      type="button"
                      onClick={() =>
                        setEditingTransaction({
                          ...editingTransaction,
                          Category: cat.label,
                        })
                      }
                      className={`flex flex-col items-center justify-center p-2 rounded-xl border transition ${
                        editingTransaction.Category === cat.label
                          ? "border-emerald-500 bg-emerald-500/10 text-white"
                          : "border-slate-800 bg-slate-950 text-slate-400 hover:border-slate-700"
                      }`}
                    >
                      <div className={`p-2 rounded-full mb-1 ${cat.color}`}>
                        {cat.icon}
                      </div>
                      <span className="text-[10px] font-medium text-center leading-tight">
                        {cat.label}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
              <select
                value={editingTransaction.Asset_ID}
                onChange={(e) =>
                  setEditingTransaction({
                    ...editingTransaction,
                    Asset_ID: e.target.value,
                  })
                }
                className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white outline-none"
              >
                {Object.values(ASSET_GROUPS).map((g) => (
                  <optgroup key={g.id} label={g.title}>
                    {assets
                      .filter((a) => getAssetGroupType(a.Type).id === g.id)
                      .map((a) => (
                        <option key={a.ID} value={a.ID}>
                          {a.Asset_Name}
                        </option>
                      ))}
                  </optgroup>
                ))}
              </select>
              <input
                type="text"
                value={editingTransaction.Note}
                onChange={(e) =>
                  setEditingTransaction({
                    ...editingTransaction,
                    Note: e.target.value,
                  })
                }
                className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-white"
              />
              <div className="flex gap-3 pt-2">
                <button
                  onClick={handleDeleteTransaction}
                  className="flex-1 bg-red-900/50 text-red-400 border border-red-900 py-3 rounded-xl font-bold flex items-center justify-center gap-2"
                >
                  <IconTrash size={16} /> ลบ
                </button>
                <button
                  onClick={handleUpdateTransaction}
                  className="flex-[2] bg-emerald-600 text-white py-3 rounded-xl font-bold"
                >
                  บันทึกการแก้ไข
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {(isCreatingAsset || editingAsset) && (
        <div className="fixed inset-0 bg-slate-950/90 backdrop-blur-md z-[60] flex items-center justify-center p-4">
          <div className="bg-slate-900 w-full max-w-sm rounded-3xl border border-slate-700 p-6 animate-fadeIn">
            <h3 className="font-bold text-white mb-2 text-center text-yellow-500">
              {isCreatingAsset ? "เพิ่มบัญชีใหม่" : "อัปเดตมูลค่า"}
            </h3>
            {editingAsset && (
              <p className="text-center text-slate-400 mb-6 font-bold text-lg">
                {editingAsset.Asset_Name}
              </p>
            )}
            <div className="space-y-4">
              {isCreatingAsset && (
                <>
                  <input
                    type="text"
                    placeholder="ชื่อบัญชี"
                    className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 text-white outline-none"
                    value={newAssetForm.name}
                    onChange={(e) =>
                      setNewAssetForm({ ...newAssetForm, name: e.target.value })
                    }
                  />
                  <select
                    className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 text-white outline-none"
                    value={newAssetForm.type}
                    onChange={(e) =>
                      setNewAssetForm({ ...newAssetForm, type: e.target.value })
                    }
                  >
                    {Object.values(ASSET_GROUPS).map((g) => (
                      <optgroup key={g.id} label={g.title}>
                        {g.types.map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </>
              )}
              {!isCreatingAsset && (
                <div>
                  <label className="text-xs text-slate-500 ml-2">
                    วันที่ของมูลค่านี้
                  </label>
                  <input
                    type="datetime-local"
                    lang="en-GB"
                    className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 text-white outline-none scheme-dark"
                    value={editingAsset.date}
                    onChange={(e) =>
                      setEditingAsset({ ...editingAsset, date: e.target.value })
                    }
                  />
                </div>
              )}
              <div>
                <label className="text-xs text-slate-500 ml-2">
                  มูลค่าปัจจุบัน (บาท)
                </label>
                <input
                  type="number"
                  placeholder="ยอดเงิน"
                  className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 text-white text-center font-bold text-3xl outline-none"
                  value={
                    isCreatingAsset
                      ? newAssetForm.value
                      : editingAsset.Current_Value
                  }
                  onChange={(e) =>
                    isCreatingAsset
                      ? setNewAssetForm({
                          ...newAssetForm,
                          value: e.target.value,
                        })
                      : setEditingAsset({
                          ...editingAsset,
                          Current_Value: e.target.value,
                        })
                  }
                />
              </div>
              <div className="flex gap-3 mt-4">
                <button
                  onClick={() => {
                    setIsCreatingAsset(false);
                    setEditingAsset(null);
                  }}
                  className="flex-1 bg-slate-800 text-slate-300 py-3 rounded-xl font-bold"
                >
                  ยกเลิก
                </button>
                <button
                  onClick={
                    isCreatingAsset ? handleCreateAsset : handleUpdateAsset
                  }
                  className="flex-1 bg-yellow-500 hover:bg-yellow-400 text-slate-900 py-3 rounded-xl font-bold"
                >
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {status && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 bg-emerald-600 text-white px-6 py-2 rounded-full shadow-xl z-[70] animate-bounce text-sm font-bold">
          {status}
        </div>
      )}
      {loading && (
        <div className="fixed inset-0 bg-slate-950/80 z-[70] flex items-center justify-center">
          <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// 6. MAIN APP CONTAINER
// ==========================================
export default function MainApp() {
  const [currentApp, setCurrentApp] = useState("project"); // 'project' or 'finance'
  return (
    <>
      {currentApp === "project" ? (
        <ProjectApp onSwitchToFinance={() => setCurrentApp("finance")} />
      ) : (
        <FinanceApp onBackToProject={() => setCurrentApp("project")} />
      )}
    </>
  );
}
